<template>
  <v-container fill-height fluid grid-list-xl>
    <v-row>
      <v-col>
        <material-card color="green" flat full-width title="Данные по заказу">
          <v-simple-table>
            <template #default>
              <tbody>
                <tr>
                  <td>id</td>
                  <td> {{ data.id }}</td>
                </tr>
                <tr>
                  <td>Коментарий менеджера</td>
                  <td><v-text-field v-model="data.managerComment" /></td>
                </tr>
                <tr>
                  <td> ID корзины </td>
                  <td> {{ cartid }}</td>
                </tr>
                <tr>
                  <td> Дата размещения </td>
                  <td>  {{ new Date(data.createdAt * 1000).toLocaleString("ru-RU") }}</td>
                </tr>
                <tr>
                  <td> Имя </td>
                  <td><v-text-field v-model="data.customerName" /></td>
                </tr>
                <tr>
                  <td> Email </td>
                  <td><v-text-field v-model="data.customerEmail" /></td>
                </tr>
                <tr>
                  <td> Телефон </td>
                  <td><v-text-field v-model="data.customerPhone" /></td>
                </tr>
                <tr>
                  <td> Доставка </td>
                  <td>
                    <v-select
                      v-model="data.deliveryId"
                      :items="getDeliveriesList()"
                      @change="selectNewDelivery()"
                    />
                    <div v-if="!$v.data.deliveryId.required" class="red--text text--lighten-1">
                      Поле обязательное для заполнения
                    </div>
                  </td>
                </tr>
                <tr>
                  <td> Оплата </td>
                  <td>
                    <v-select
                      v-model="data.paymentId"
                      :items="getPaymentsList()"
                      @change="selectNewPayment()"
                    />
                    <div v-if="!$v.data.paymentId.required" class="red--text text--lighten-1">
                      Поле обязательное для заполнения
                    </div>
                  </td>
                </tr>
                <tr>
                  <td> Промокод </td>
                  <td><v-text-field v-model="promoCode" /></td>
                </tr>
                <tr>
                  <td> Адрес </td>
                  <td><v-text-field v-model="address" /> {{ address }}</td>
                </tr>
                <tr>
                  <td> Комментарий к заказу</td>
                  <td><v-text-field v-model="data.customerComment" /></td>
                </tr>
                <tr>
                  <td> Дата завершения </td>
                  <td>  {{ new Date(data.updatedAt * 1000).toLocaleString("ru-RU") }}</td>
                </tr>
                <tr>
                  <td>  Сумма заказа </td>
                  <td>{{ getOrderSum() }}</td>
                </tr>
                <tr>
                  <td>  Стоимость доставки </td>
                  <td>{{ getDeliveryPrice() }}</td>
                </tr>
                <tr>
                  <td> Скидка к заказу </td>
                  <td>{{ getOrderDiscount() }}%</td>
                </tr>
                <tr>
                  <td> Сумма с учетом скидки</td>
                  <td><v-text-field v-model="data.sumTotal" /></td>
                </tr>
                <tr>
                  <td> Общая сумма с доставкой</td>
                  <td>{{ getOrderTotalSum() }}</td>
                </tr>
                <tr>
                  <td> Статус</td>
                  <td>
                    <v-select
                      v-model="data.status"
                      :items="statusList"
                    />
                  </td>
                </tr>
                <tr>
                  <td>Трек-номер CДЕК</td>
                  <td><v-text-field v-model="trackNumber" /></td>
                </tr>
                <tr v-if="trackNumber && trackNumber.length > 0">
                  <td><a :href="getCdekLink(trackNumber)" target="_blank">Отследить</a></td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </material-card>
      </v-col>
    </v-row>
    <v-row v-if="hasCertificate">
      <v-col>
        <material-card color="green" flat full-width title="Применённые сертификаты">
          <v-data-table
            :headers="headerCertificates"
            :items="data.certificates"
            class="elevation-1"
            hide-default-footer
          >
          </v-data-table>
        </material-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <material-card color="green" flat full-width title="Заказы пользователя">
          <v-data-table
            :headers="headerUserOrdersInfo"
            :items="computedUserInfoData"
            class="elevation-1"
            hide-default-footer
          >
            <template #item.status="{ item }">
              {{ getStatus(item) }}
            </template>
          </v-data-table>
        </material-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <material-card color="green" flat full-width title="Товары в заказе">
          <v-data-table
            :headers="headersProduct"
            :items="orderItems"
            :loading="loadingProducts"
            class="elevation-1"
            hide-default-footer
          >
            <template #item.offerId="{ item }">
              <a :href="getOuterLinkToOffer(item)" target="_blank">{{ item.offerId }}</a>
            </template>
            <template #item.image="{ item }">
              <v-img
                width="50px"
                height="50px"
                :src="`${getImage(item)}`"
              />
            </template>
            <template #item.art="{ item }">
              {{ getArtNumber(item) }}
            </template>
            <template #item.name="{ item }">
              {{ item.name }}
            </template>
            <template #item.discount="{ item }">
              {{ getDiscount(item) }}%
            </template>
            <template #item.quantity="{ item }">
              <v-text-field v-model="item.quantity" type="number" min="1" @change="recalc" @keyup="checkQuantityForZero($event)" @keydown="checkQuantityInput($event, item.quantity)"/>
            </template>
            <template #[`item.action`]="{ item }">
              <v-icon small class="mr-2" @click="delProduct(item)">
                mdi-bucket
              </v-icon>
            </template>
          </v-data-table>
          <select-c @selected="addItem" />
          <v-btn color="blue darken-1" text @click="addOffers">
            Добавить
          </v-btn>
        </material-card>
      </v-col>
    </v-row>
    <v-row v-if="giftItems">
      <v-col>
        <material-card color="green" flat full-width title="Подарки в заказе">
          <v-data-table
            :headers="headersGifts"
            :items="giftItems"
            :loading="loadingGifts"
            class="elevation-1"
            hide-default-footer
          >
            <template #item.offerId="{ item }">
              <a :href="getOuterLinkToOffer(item)" target="_blank">{{ item.offerId }}</a>
            </template>
            <template #item.image="{ item }">
              <v-img
                width="50px"
                height="50px"
                :src="`${getImage(item)}`"
              />
            </template>
            <template #item.art="{ item }">
              {{ getArtNumber(item) }}
            </template>
            <template #item.name="{ item }">
              {{ item.name }}
            </template>
          </v-data-table>
        </material-card>
      </v-col>
    </v-row>
    <v-btn color="blue" :disabled="$v.$invalid" @click="save" >
      СОХРАНИТЬ!
    </v-btn>
  </v-container>
</template>

<script>
import getCdekLink from '@/helpers/cdek'
import orderMixin from '@/helpers/orders'
import { getUserOrdersInfo, order, updateOrder } from '@/graphql/orders'
import { getDeliveries } from '@/graphql/deliveries'
import { getPayments } from '@/graphql/payments'
import { calculateCartDiscount } from '@/graphql/discounter'
import SelectC from '@/components/offers/select'
import Vue from 'vue'
import Vuelidate from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
Vue.use(Vuelidate)
export default {
  name: 'ViewOrder',
  components: {
    SelectC
  },
  mixins: [getCdekLink, orderMixin],
  layout: 'dashboard',
  apollo: {
    Order: {
      query: order,
      result ({
                data,
                loading
              }) {
        if (data !== undefined && data.order !== null) {
          this.data = data.order
        }
      },
      variables () {
        return {
          id: this.$route.params.id
        }
      },
      update: data => data.order
    },
    Deliveries: {
      query: getDeliveries,
      result ({
                data,
                loading
              }) {
        if (data?.deliveries?.data) {
          this.deliveries = data.deliveries.data
        }
      },
      update: data => data.deliveries.data,
      variables () {
        return {
          filter: {
            status: 'ACTIVE'
          }
        }
      }
    },
    Payments: {
      query: getPayments,
      result ({
                data,
                loading
              }) {
        if (data?.payments?.data) {
          this.payments = data.payments.data
        }
      },
      update: data => data.payments.data,
      variables () {
        return {
          filter: {
            status: 'ACTIVE'
          }
        }
      }
    },
    UserOrderInfo: {
      query: getUserOrdersInfo,
      result ({
                data,
                loading
              }) {
        if (data?.getUserOrdersInfo) {
          this.userOrdersInfoData = data.getUserOrdersInfo
        }
      },
      update: data => data.getUserOrdersInfo,
      variables () {
        return {
          userId: this?.data?.userId
        }
      },
      skip () {
        return !this?.data?.userId
      }
    }
  },
  validations: {
    data: {
      deliveryId: {
        required
      },
      paymentId: {
        required
      }
    }
  },
  data () {
    return {
      edited: false,
      loadingProducts: false,
      loadingGifts: false,
      loadingUserOrdersInfo: false,
      userOrdersInfoData: [],
      itemsAdded: [],
      selectedItem: {},
      deliveries: {},
      deliveryInfo: {
        address: '',
        date: '',
        time: '',
        trackNumber: ''
      },
      payments: {},
      data: {
        id: this.$route.params.id
      },
      gifts: [],
      cartid: this.data?.cart?.id,
      headerCertificates: [
        { value: 'number', text: 'Номер' },
        { value: 'nominal', text: 'Номинал' }
      ],
      headersProduct: [
        {
          text: 'Id',
          value: 'offerId'
        },
        {
          text: 'Фото',
          value: 'image'
        },
        {
          text: 'Артикул',
          value: 'art'
        },
        {
          text: 'Название',
          value: 'name'
        },
        {
          text: 'Цена',
          value: 'price'
        },
        {
          text: 'Кол-во',
          value: 'quantity'
        },
        {
          text: 'Скидка',
          value: 'discount'
        },
        {
          text: 'Сумма',
          value: 'sumTotal'
        },
        {
          text: '#',
          value: 'action'
        }
      ],
      headersGifts: [
        {
          text: 'Id',
          value: 'offerId'
        },
        {
          text: 'Фото',
          value: 'image'
        },
        {
          text: 'Артикул',
          value: 'art'
        },
        {
          text: 'Название',
          value: 'name'
        }
      ],
      headerUserOrdersInfo: [
        {
          text: 'Статус',
          value: 'status'
        },
        {
          text: 'Сумма',
          value: 'amount'
        },
        {
          text: 'Кол-во',
          value: 'quantity'
        }
      ]
    }
  },
  computed: {
    promoCode: {
      get () {
        return this.data?.extraFields?.promoCode
      },
      set (val) {
        if (this.data.extraFields) {
          this.data.extraFields.promoCode = val
        } else {
          this.data.extraFields = {
            promoCode: val
          }
        }
      }
    },
    address: {
      get () {
        if (this.data?.deliveryInfo?.address) {
          return this.data?.deliveryInfo?.address
        } else {
          return ''
        }
      },
      set (val) {
        if (this.data.deliveryInfo) {
          this.data.deliveryInfo.address = val
        } else {
          this.data.deliveryInfo = {
            address: val
          }
        }
      }
    },
    trackNumber: {
      get () {
        return this.data?.deliveryInfo?.trackNumber
      },
      set (val) {
        if (this.data.deliveryInfo) {
          this.data.deliveryInfo.trackNumber = val
        } else {
          this.data.deliveryInfo = {
            trackNumber: val
          }
        }
      }
    },
    hasCertificate () {
      return this?.data?.certificates?.length > 0
    },
    orderItems () {
      return this?.data?.items?.filter(item => item?.extraFields?.isGift === false)
    },
    giftItems () {
      const gifts = this?.data?.items?.filter(item => item?.extraFields?.isGift === true)
      return gifts?.length > 0 ? gifts : false
    },
    computedUserInfoData () {
      return this.userOrdersInfoData ?? []
    }
  },
  methods: {
    getOrderDiscount () {
      const oneP = this.getOrderSum() / 100
      const pp = this.data?.sumTotal / oneP
      return Math.round(100 - pp)
    },
    getOrderSum () {
      let summ = 0
      this.data?.items?.filter(item => !item?.extraFields?.isGift).forEach((item) => {
        summ = summ + parseFloat(item.price)
      })
      return summ
    },
    getOrderTotalSum () {
      return parseFloat(this?.data?.sumTotal ?? 0) + parseFloat(this?.data?.deliveryPrice ?? 0)
    },
    getDeliveryPrice () {
      return this.data.deliveryPrice ?? 0
    },
    getDiscount (item) {
      const oneP = (item.price * item.quantity) / 100
      const pp = item.sumTotal / oneP
      return Math.round(100 - pp)
    },
    getImage (item) {
      return item?.offer?.images?.[0].file?.url
    },
    getArtNumber (item) {
      const artParam = item?.offer?.params.filter(param => param.slug === 'art')
      return artParam?.length ? artParam[0]?.value : ''
    },
    getOuterLinkToOffer (item) {
      return 'https://nasonpearl.ru/item/' + item?.offerId
    },
    getDeliveriesList () {
      return this?.deliveries.length > 0 ? this?.deliveries?.map(item => ({ text: this.getFullDeliveryName(item.name, item.group_name), value: item.id })) : []
    },
    getPaymentsList () {
      return this?.payments.length > 0 ? this?.payments?.map(item => ({ text: item.name, value: item.id })) : []
    },
    getFullDeliveryName (name, groupName) {
      return name + ' (' + groupName + ')'
    },
    selectNewDelivery () {
      const selectedDelivery = this?.deliveries?.filter(item => item.id === this.data.deliveryId)[0]
      if (selectedDelivery) {
        this.data.deliveryName = this.getFullDeliveryName(selectedDelivery.name, selectedDelivery.group_name)
        this.data.deliveryPrice = selectedDelivery.sum ?? 0
      }
    },
    selectNewPayment () {
      this.data.paymentName = this?.payments?.filter(item => item.id === this.data.paymentId)[0]?.name
    },
    addItem (val) {
      this.itemsAdded = val
    },
    addOffers () {
      this.itemsAdded.forEach((item) => {
        if (item.id) {
          const fil = this.data.items.filter(i => i.id === item.id)
          if (fil.length > 0) {
            fil[0].quantity = fil[0].quantity + 1
          } else {
            this.data.items.push({
              id: item.id,
              offerId: item.id.toString(),
              name: item.name,
              price: item.price,
              quantity: 1,
              sumTotal: item.price,
              offer: {
                params: item.params,
                images: item.images
              },
              extraFields: {
                isGift: false
              }
            })
          }
        }
      })
      this.recalc()
    },
    recalc () {
      this.loadingProducts = true
      const offers = []
      this.orderItems.forEach((item) => {
        let cats = []
        if (item.offer?.category) {
          cats = item.offer?.category?.map((i) => {
            return {
              id: String(i),
              isPartnerCategory: false
            }
          })
        }
        if (item.offer?.category_id > 0) {
          cats.push({
            id: String(item.offer?.category_id),
            isPartnerCategory: false
          })
        }
        const pearlType = item?.offer?.params?.find(param => param?.slug === 'pearlType')?.value || null
        const pearlColor = item?.offer?.params?.find(param => param?.slug === 'color')?.value
        const pearlDoubleColor = item?.offer?.params?.find(param => param?.slug === 'doublecolor')?.value
        offers.push({
          id: String(item?.offerId),
          price: item.price,
          oldPrice: item.oldPrice,
          quantity: parseInt(item.quantity),
          categories: cats,
          pearlType,
          pearlColor: (pearlColor && pearlColor !== '-1') ? pearlColor : pearlDoubleColor
        })
      })

      const input = {
        offers,
        promoCode: this.promoCode,
        certificatesTotalSum: 0,
        usersOrderTotalSum: 0
      }
      this.$apollo
          .mutate({
            mutation: calculateCartDiscount,
            variables: { input }
          })
          .then((data) => {
            const rez = data?.data?.calculateCartDiscount
            if (rez?.totalSum) {
              this.data.sumTotal = rez?.totalSum
            }
            const newOffers = []
            rez?.offers?.forEach((item, index) => {
              let offer = this.getOfferById(item.id)
              if (offer.length > 0) {
                offer = offer[0]
                offer.sumTotal = item.totalSum
              } else if (this.isGiftType(item?.type)) {
                offer = {
                  offerId: item.id,
                  name: item?.offer?.name ?? '',
                  price: 0,
                  quantity: 1,
                  sumTotal: 0,
                  offer: item.offer,
                  extraFields: {
                    isGift: this.isGiftType(item?.type)
                  }
                }
              } else {
                offer = {
                  offerId: item.id,
                  name: item?.offer?.name ?? '',
                  price: 0,
                  quantity: 1,
                  sumTotal: 0,
                  offer: item.offer,
                  extraFields: {
                    isGift: this.isGiftType(item?.type)
                  }
                }
              }
              newOffers.push(offer)
            })
            if (newOffers.length > 0) {
              this.data.items = newOffers
            }
            this.loadingProducts = false
          })
          .catch((error) => {
            console.error(error)
          })
    },
    delProduct (item) {
      this.data.items = this.data.items.filter(i => i.id !== item.id)
      this.recalc()
    },
    save () {
      const data = Object.assign({}, this.data)
      delete data?.deliveryInfo?.__typename
      delete data?.extraFields?.__typename
      data.items?.forEach((item) => {
        delete item.id
        delete item.offer
        delete item.__typename
        delete item?.extraFields?.__typename
        item.quantity = parseInt(item.quantity)
      })
      delete data.id
      delete data.uuid
      delete data.manager
      delete data.createdAt
      delete data.updatedAt
      delete data.__typename
      delete data?.extraFields?.__typename
      delete data.certificates
      data.sumTotal = parseFloat(data.sumTotal)
      this.$apollo
          .mutate({
            mutation: updateOrder,
            variables: {
              id: parseInt(this.$route.params.id),
              input: data
            }
          })
          .then((data) => {
            console.log(data)
          })
          .catch((error) => {
            console.error(error)
          })
    },
    getOfferById (id) {
      return this.data.items.filter(item => item.offerId === id)
    },
    isGiftType (type) {
      return type === 'gift'
    },
    checkQuantityForZero (event) {
      if (event.target.value.startsWith('0')) {
        event.target.value = event.target.value.replace(/^0*/, '')
      }
    },
    checkQuantityInput (e, value) {
      if (/-/.test(e.key)) {
        e.preventDefault()
      }
    }
  }
}
</script>
